module.exports = __webpack_public_path__ + "img/SysComm.6d88e7f2.png";